export const FIRST_NAME = 'firstName';
export const MIDDLE_NAME = 'middleName';
export const LAST_NAME = 'lastName';
export const CURRENT_ADDRESS = 'currentAddress';
export const CURRENT_STATE = 'currentState';
export const CURRENT_CITY = 'currentCity';
export const CURRENT_ZIP = 'currentZip';
export const DOB = 'dob';
export const PHONE = 'phone';
export const SSN = 'ssn';
